import App from 'app/app.js';

function EventDataService() {
  this.formatEventData = function (event, masterSubject, subjectRelationship) {
    var eventData = {
      subjectFirstName: masterSubject.subjectFirstName || event.subjectInfo.firstName,
      subjectLastName: masterSubject.subjectLastName || event.subjectInfo?.lastName,
      subjectRelationship: subjectRelationship,
      subjectGrade: masterSubject.currentGrade || masterSubject.subjectGrade || event.subjectInfo?.grade
    };
    if (event && event.subjectInfo && event.subjectInfo.portraitIdAccessCode != null) {
      var codes = this.getPortraitAndAccessCodes(event);
      return Object.assign(eventData, codes);
    }
    return Object.assign(eventData, { pictureDayId: event.eventType.jobNumber });
  };

  this.getPortraitAndAccessCodes = (event) => {
    return this.parseAccessCredential(event.subjectInfo.portraitIdAccessCode);
  };

  this.parseAccessCredential = (accessCredential) => {
    return {
      portraitId: `${accessCredential.slice(0, 4)}-${accessCredential.slice(4, 8)}`,
      accessCode: accessCredential.slice(8)
    };
  };
}
App.service('EventDataService', [EventDataService]);
